import { getAuth } from "firebase/auth";
import { addDoc, collection } from "firebase/firestore";
import { ref, uploadBytes } from "firebase/storage";
import { getCurrentDate } from "../../../helper/time";
import { updateMoreInfo } from "../../MoreInfo/create";
import { db, storage } from "../../setup";

function getFileExtension(filename) {
  if (filename?.includes(".")) {
    return filename.split(".").pop();
  }
  return "";
}

// Create an object in the "Userhelp/bugs" collection
export const createBugReport = async (bugData) => {
  console.log("Creating bug report with data:", {
    text: bugData.text,
    reported_by: getAuth().currentUser.email,
    createdAt: getCurrentDate(),
    ss: bugData.screenshotUrl ? true : false,
    file: bugData.file ? true : false,
    fileName: bugData.file?.name,
    url: window.location.href,
    tag: bugData.tag,
  });
  
  try {
    const bugsRef = collection(db, "bugs");
    const dataToAdd = {
      text: bugData.text,
      reported_by: getAuth().currentUser.email,
      createdAt: getCurrentDate(),
      ss: bugData.screenshotUrl ? true : false,
      file: bugData.file ? true : false,
      fileName: bugData.file?.name,
      url: window.location.href,
      tag: bugData.tag,
    };
    
    // Remove fileName if no file is provided
    if (!dataToAdd.fileName) delete dataToAdd.fileName;
    
    // Create the bug document
    const newBugRef = await addDoc(bugsRef, dataToAdd);
    console.log("Bug created with ID:", newBugRef.id);
    
    // Update more info
    await updateMoreInfo({ 
      location: window.location.href, 
      date: getCurrentDate() 
    }, "bug_" + newBugRef.id);

    // Upload file if provided
    if (bugData.file) {
      console.log("Uploading file:", bugData.file.name);
      const file = bugData.file;
      const fileExtension = getFileExtension(bugData.file.name);
      const storageRef = ref(storage, `userhelp/bugs/${newBugRef.id}_file.${fileExtension}`);
      
      try {
        await uploadBytes(storageRef, file);
        console.log("File uploaded successfully");
      } catch (fileError) {
        console.error("Error uploading file:", fileError);
        throw new Error(`Failed to upload file: ${fileError.message}`);
      }
    }

    // Upload screenshot if provided
    if (bugData.screenshotUrl) {
      console.log("Uploading screenshot");
      const imageUrl = bugData.screenshotUrl;

      // Convert base64 to Blob
      const dataURItoBlob = (dataURI) => {
        const byteString = atob(dataURI.split(",")[1]);
        const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
      };

      const imageBlob = dataURItoBlob(imageUrl);
      const storageRef = ref(storage, `userhelp/bugs/${newBugRef.id}.png`);
      
      try {
        await uploadBytes(storageRef, imageBlob);
        console.log("Screenshot uploaded successfully");
      } catch (imageError) {
        console.error("Error uploading screenshot:", imageError);
        throw new Error(`Failed to upload screenshot: ${imageError.message}`);
      }
    }

    console.log("Bug report created successfully");
    return newBugRef.id;
  } catch (error) {
    console.error("Error creating bug report:", error);
    throw error;
  }
};
